import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/esm/Col';
import formatBytes from '../../../utils/FormatBytes';

function DocumentCard({ document, onDelete, onOpen, chosenDocument }) {
  return (
    <Card>
      <Card.Body>
        <Col className='d-flex flex-column'>
          <div className='d-flex align-items-center justify-content-between'>
            <span className='text-secondary' style={{ marginRight: '10px' }}>
              Visningsnamn
            </span>
            <span
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {document?.displayName}
            </span>
          </div>
          <div className='d-flex align-items-center justify-content-between pt-2'>
            <span className='text-secondary' style={{ marginRight: '10px' }}>
              Filnamn
            </span>
            <span
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {document?.fileName}
            </span>
          </div>
          <div className='d-flex align-items-center justify-content-between pt-2'>
            <span className='text-secondary'>Storlek</span>
            <span>{formatBytes(document.size)}</span>
          </div>
        </Col>

        <Card.Footer className='mt-2'>
          <div className='d-flex gap-5 justify-content-between'>
            <div
              className='d-flex gap-2 justify-content-end align-items-center'
              role='button'
              onClick={() => {
                chosenDocument(document?.fileUrl.split('/')[3]);
                onDelete();
              }}
            >
              <span className='material-symbols-outlined'>delete</span>
              <span>Radera</span>
            </div>
            <Button
              variant='outline-primary'
              className='d-flex align-items-center'
              onClick={() => {
                onOpen(document?.fileUrl);
              }}
            >
              <span
                className='material-symbols-outlined me-2'
                style={{ fontSize: '18px' }}
              >
                open_in_new
              </span>
              Öppna
            </Button>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default DocumentCard;
